import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-restaurant',
  templateUrl: './restaurant.component.html',
  styleUrls: ['./restaurant.component.css']
})
export class RestaurantComponent implements OnInit {

  selectedCategory: string = '';
  category: string | null = "burgers";

  constructor(
    private titleService: Title,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.titleService.setTitle('LaBurgers | Menu');
  
    this.route.params.subscribe(params => {
      this.category = params['category'] ?? null;
  
      if (this.category) {
        this.selectedCategory = this.category.toLowerCase();
        setTimeout(() => {
          this.scrollToBrowseSection();
        }, 200);
      } else {
        this.selectedCategory = "burgers";
      }
    });
  }
  scrollToBrowseSection() {
    const el = document.getElementById('browseCategorySection');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  

  filterCategory(cat: string) {
    debugger;
    this.selectedCategory = cat.toLowerCase();
  }
}
